import * as ActionTypes from '../actions/actionTypes';
import {CENTER_MESSAGE_TYPES} from '../Constants';

const initialState = {
  graphs_open: false,
  popup_open: false,
  graph_view_expanded: false,
  pop_out: false,
  popup_expanded: false,
  indicators_list_open: true,
  legend_list_open: false,
  boundaries_list_open: false,
  active_location_search: false,
  active_menu: null,
  centre_message: null,
  centre_message_type: CENTER_MESSAGE_TYPES.INFO,
  loading_message: null,
  point_data_display_graph: true,
  disclaimer_open: true,
  print_on_load: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_POINT:
      return {
        ...state,
        popup_open: action.open_popup,
        centre_message: null
      };

    case ActionTypes.CLOSE_POPUP:
      return {
        ...state,
        popup_open: false
      };

    case ActionTypes.START_PLAYING:
      return {
        ...state,
        popup_open: false,
        popup_expanded: false
      };

    case ActionTypes.OPEN_GRAPHS_VIEW:
      return {
        ...state,
        graphs_open: true,
        active_menu: null,
        indicators_list_open: false,
        legend_list_open: false,
        boundaries_list_open: false
      };

    case ActionTypes.CLOSE_GRAPHS_VIEW:
      return {
        ...state,
        graphs_open: false
      };

    case ActionTypes.TOGGLE_POPUP_EXPANDED:
      return {
        ...state,
        popup_expanded: !state.popup_expanded
      };

    case ActionTypes.SET_POP_OUT:
      return {
        ...state,
        pop_out: true,
        disclaimer_open: false,
        print_on_load: action.print_on_load
      };

    case ActionTypes.TOGGLE_GRAPHS_EXPANDED:
      return {
        ...state,
        graph_view_expanded: !state.graph_view_expanded
      };

    case ActionTypes.SET_GRAPHS_EXPANDED:
      return {
        ...state,
        graph_view_expanded: action.data
      };

    case ActionTypes.TOGGLE_POINT_DATA_DISPLAY:
      return {
        ...state,
        point_data_display_graph: !state.point_data_display_graph
      };

    case ActionTypes.START_LOCATION_SEARCH:
      return {
        ...state,
        active_location_search: true
      };

    case ActionTypes.STOP_LOCATION_SEARCH:
      return {
        ...state,
        active_location_search: false
      };

    case ActionTypes.DROPDOWN_LEGEND_OPEN:
      return {
        ...state,
        legend_list_open: action.open || state.active_menu !== null
      };

    case ActionTypes.DROPDOWN_INDICATORS_OPEN:
      return {
        ...state,
        indicators_list_open: action.open || state.active_menu !== null
      };

    case ActionTypes.DROPDOWN_BOUNDARIES_OPEN:
      return {
        ...state,
        boundaries_list_open: action.open || state.active_menu !== null
      };

    case ActionTypes.TOGGLE_MENU:
      const toggleToClosed = action.menu_name === state.active_menu;
      return {
        ...state,
        active_menu: toggleToClosed ? null : action.menu_name,
        indicators_list_open: !toggleToClosed && action.menu_name === 'indicators',
        legend_list_open: !toggleToClosed && action.menu_name === 'legend',
        boundaries_list_open: !toggleToClosed && action.menu_name === 'boundaries'
      };

    case ActionTypes.SET_CENTRE_MESSAGE:
      return {
        ...state,
        centre_message: action.message,
        centre_message_type: action.type || CENTER_MESSAGE_TYPES.INFO
      };

    case ActionTypes.SWITCH_ACTIVE_INDICATOR:
    case ActionTypes.TOGGLE_INCIDENT_TYPE:
    case ActionTypes.TOGGLE_OVERLAY:
      return {
        ...state,
        centre_message: null
      };

    case ActionTypes.SET_LOADING_MESSAGE:
      return {
        ...state,
        loading_message: action.message
      };

    case ActionTypes.TOGGLE_DISCLAIMER:
      return {
        ...state,
        disclaimer_open: !state.disclaimer_open
      };

    case ActionTypes.SET_QS_STATION_ID:
      return {
        ...state,
        disclaimer_open: false
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/view.js